import styled from "styled-components/macro";

const LsbCloseBtn = styled.button`
  border: 1px solid rgba(220, 220, 230, 0.2);
  background-color: rgba(250, 250, 252, 0.1);
`;

export default LsbCloseBtn;
